import comp from "./Footer";
export default comp;
